import React from 'react';
import { Box, Typography } from '@mui/material';
import image from '../../assets/images/no-data.svg';

interface IProps {
  title?: string;
}

const EmptySectionMessage = ({ title }: IProps) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      mt={4}
    >
      <Box component="img" src={image} maxWidth="200px"></Box>
      <Typography variant="h5" textAlign="center" mt={4}>
        {title}
      </Typography>
    </Box>
  );
};

export default EmptySectionMessage;
